import PropTypes from 'prop-types';

const Title = ({ type, groupName }) => {
  switch (type) {
    case 'subgroup':
      return <div>Add sub-group</div>;
    case 'edit':
      return <div>Edit Group</div>;
    case 'create':
      return <div>Add new Group</div>;
    case 'import':
      return (
        <div>
          <div className="cmb-4">Import to Company</div>
          <div className="fw-bold fs-12 text-dark">{groupName}</div>
        </div>
      );
    default:
      return null;
  }
};

const Header = ({ type, groupName }) => {
  return <Title type={type} groupName={groupName} />;
};

export default Header;

Header.propTypes = {
  type: PropTypes.string.isRequired,
  groupName: PropTypes.string
};

Title.propTypes = {
  type: PropTypes.string.isRequired,
  groupName: PropTypes.string
};
